import { defineMessages } from 'react-intl';

export default defineMessages({
    perPerson: {
        "id": "twia-tfpa.claims.Coverages.per person",
        "defaultMessage": "Per Person"
    },
    perAccident: {
        "id": "twia-tfpa.claims.Coverages.per accident",
        "defaultMessage": "Per Accident"
    },
    limit: {
        "id": "twia.claims.Coverages.Limit",
        "defaultMessage": "Limit"
    }
})